import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const NfcIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"nfc"} ref={ref}/>
});

NfcIcon.displayName = "NfcIcon";
